class TdProductSwatch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Find the swatch container
    const swatchContainer = this.querySelector('.swatch[data-option-index]');
    if (!swatchContainer) return;
    
    // Find the existing span element
    const titleSpan = swatchContainer.querySelector('.swatch-block-header span');
    if (!titleSpan) return;
    
    // Find all radio inputs in the swatch container
    const swatchInputs = swatchContainer.querySelectorAll('input[type="radio"]');
    
    // Function to update the selected color text
    const updateSelectedColor = () => {
      const selectedInput = swatchContainer.querySelector('input[type="radio"]:checked');
      if (selectedInput) {
        titleSpan.textContent = `- ${selectedInput.value}`;
      } else {
        titleSpan.textContent = '';
      }
    };
    
    // Add change event listeners to all swatch inputs
    swatchInputs.forEach(input => {
      input.addEventListener('change', updateSelectedColor);
    });
    
    // Set initial value
    updateSelectedColor();
  }
}

// Register the custom element
customElements.define('td-product-customization', TdProductSwatch);
